import React from 'react'

import { Skeleton } from '@fourthwall/components'

export const BadgesSkeleton = () => (
  <Skeleton gap={40}>
    <Skeleton gap={16}>
      <Skeleton.Shape width="100%" height={40} />
      <Skeleton.Shape width="100%" height={90} />
      <Skeleton.Shape width="100%" height={90} />
      <Skeleton.Shape width="100%" height={90} />
    </Skeleton>
    <Skeleton gap={16}>
      <Skeleton.Shape width="100%" height={40} />
      <Skeleton.Shape width="100%" height={140} />
    </Skeleton>
  </Skeleton>
)
